const IntersectionObserverAnimations = () => {
	const observer = new IntersectionObserver(
		(entries) => {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					entry.target.classList.add('in-view');
					observer.unobserve(entry.target);
				}
			});
		},
		{
			rootMargin: '0px 0px -50px 0px',
			threshold: 0.1 // Only needs to be 10% visible to trigger
		}
	);

	// Observe all elements immediately - no need for setTimeout
	document.querySelectorAll('.io-animation').forEach(domEl => observer.observe(domEl));

	// Cleanup function for React if needed
	return () => observer.disconnect();
};

export default IntersectionObserverAnimations;